<template>
    <div class="half-pie-chart">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import { PieChart } from "echarts/charts";

echarts.use([PieChart]);

Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=pie-nest
export default Vue.extend({
    name: "HalfPieChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        subTitle: {
            type: String,
            default: "",
        },
        series: {
            type: Array,
            default: () => [],
        },
        colors: {
            type: Array,
            default: () => undefined,
        },
    },
    methods: {
        getOptions() {
            const options = {
                grid: {
                    top: 50,
                    width: "100%",
                    height: "auto",
                    left: 0,
                    containLabel: true,
                },
                title: [
                    {
                        text: this.title,
                        subtext: this.subTitle,
                        left: "14%",
                        textAlign: "center",
                        textStyle: {
                            width: "100%",
                            overflow: "break",
                            lineHeight: 30,
                        },
                    },
                ],
                toolbox: {
                    show: true,
                    feature: {
                        dataZoom: {
                            yAxisIndex: "none",
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ["line", "bar"] },
                        restore: {},
                        saveAsImage: {},
                    },
                },
                legend: {
                    top: "5%",
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                },
                series: this.series,
            };
            if (this.colors) {
                options.color = this.colors;
            }
            return options;
        },
    },
});
</script>

<style scoped lang="scss">
.half-pie-chart {
    width: 100%;
    height: 300px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
